import React, { useEffect, useCallback } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import MetaTags from './components/MetaTags';
import './style.css';

import Main from './home';
import Policy from './policy';
import TeacherPolicy from './teacherpolicy';
import Contact from './contact';
import Portfolio from './portfolio';
import Scientific from './scientific';
import Mobileapp from './mobileapp';
import Website from './websitedevelopment';
import Services from './services';
import Resetpassword from './resetpassword';
import Aboutus from './aboutus';
import Footer from './footer';
import AffiliateLogin from './affiliateLogin';
import AffiliateRegister from './affiliateRegister';
import AffiliateDashboard from './affiliateDashboard';
import AffiliateProgram from './affiliate';
import Apply from './apply';
import Logo from './img/logo.png';
import Scroll from './scrollToTop';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Button from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Menu1 from '@material-ui/icons/Menu';

const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/solution', label: 'Our Solution' },
  { to: '/register', label: 'Register' },
  { to: '/aboutus', label: 'About Us' },
  { to: '/contact', label: 'Contact' },
  { to: '/affiliate', label: 'Affiliate Program' },
];

const useStyles = makeStyles((theme) => ({
  list: {
    width: 280,
  },
  fullList: {
    width: 'auto',
  },
  displayer_small: {
    [theme.breakpoints.up('xs')]: {
      display: 'flex',
    },
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  displayer_big: {
    [theme.breakpoints.up('xs')]: {
      display: 'none',
    },
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  mobileBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    minHeight: 56,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    boxSizing: 'border-box',
  },
  mobileLogoLink: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    minHeight: 48,
  },
}));

function Menu() {
  const classes = useStyles();
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [scrollPosition, setScrollPosition] = React.useState(0);

  const handleScroll = useCallback(() => {
    setScrollPosition(window.pageYOffset);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const navClass = scrollPosition > 40 ? 'before' : 'after';

  const drawerList = () => (
    <div
      className={classes.list}
      role="presentation"
      onClick={() => setDrawerOpen(false)}
      onKeyDown={() => setDrawerOpen(false)}
    >
      <List component="nav" aria-label="Main navigation">
        {NAV_LINKS.map(({ to, label }) => (
          <ListItem
            button
            key={to}
            component={Link}
            to={to}
            onClick={() => setDrawerOpen(false)}
          >
            <ListItemText primary={label} />
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <HelmetProvider>
      <Router>
        <MetaTags />
        <div className={classes.displayer_big}>
          <div
            className={clsx('nav-wrapper', 'containe', navClass)}
            style={{ transition: 'all 0.4s ease-in-out' }}
          >
            <Link to="/" className="logo-container">
              <img
                src={Logo}
                className="logo_img"
                alt="SIS Revolution — Home"
              />
            </Link>
            <ul className="right hide-on-med-and-down">
              {NAV_LINKS.filter((l) => l.to !== '/').map(({ to, label }) => (
                <li key={to}>
                  <Link to={to}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className={classes.displayer_small}>
          <div className={classes.mobileBar}>
            <Button
              aria-label="Open menu"
              aria-expanded={drawerOpen}
              aria-controls="mobile-navigation-drawer"
              onClick={() => setDrawerOpen(true)}
            >
              <Menu1 />
            </Button>
            <Link to="/" className={classes.mobileLogoLink}>
              <img
                src={Logo}
                className="logo_img_small"
                alt="SIS Revolution — Home"
              />
            </Link>
            <span style={{ width: 48 }} aria-hidden="true" />
          </div>
          <Drawer
            id="mobile-navigation-drawer"
            anchor="left"
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
          >
            {drawerList()}
          </Drawer>
        </div>

        <Scroll />

        <Switch>
          <Route path="/register">
            <Portfolio />
          </Route>
          <Route path="/aboutus">
            <Aboutus />
          </Route>
          <Route path="/resetpassword">
            <Resetpassword />
          </Route>
          <Route path="/contact">
            <Contact />
          </Route>
          <Route path="/solution">
            <Services />
          </Route>
          <Route path="/policy">
            <Policy />
          </Route>
          <Route path="/teacherpolicy">
            <TeacherPolicy />
          </Route>
          <Route exact path="/apply">
            <Apply />
          </Route>
          <Route path="/apply/:schoolID">
            <Apply />
          </Route>
          <Route exact path="/affiliate/login">
            <AffiliateLogin />
          </Route>
          <Route exact path="/affiliate/register">
            <AffiliateRegister />
          </Route>
          <Route exact path="/affiliate/dashboard">
            <AffiliateDashboard />
          </Route>
          <Route path="/affiliate">
            <AffiliateProgram />
          </Route>
          <Route path="/">
            <Main />
          </Route>
        </Switch>

        <Footer />
      </Router>
    </HelmetProvider>
  );
}

export default Menu;
